import PairingWizardModel from "./PairingWizardModel.js";
import StepSetup from "./steps/PluginSetup.js";
export default {
  install(molten) {
    StepSetup.install(molten);
    molten.addPlugin('Model', {
      type: PairingWizardModel.TYPE,
      model: PairingWizardModel
    });
  }
};